module.exports = __webpack_public_path__ + "media/images/icons/horn-a6da606dc50559846d76205393387c08.svg";